/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MapCheapestRate_jsonld } from './MapCheapestRate_jsonld';
export type MapAccommodation_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    type: string;
    id: string;
    cheapestRate: MapCheapestRate_jsonld | null;
    reservationType: MapAccommodation_jsonld.reservationType;
};
export namespace MapAccommodation_jsonld {
    export enum reservationType {
        REAL_TIME = 'RealTime',
        QUERY = 'Query',
    }
}
